import type { Dance } from '../api/danceApi';

function normalize(s: string): string {
  return s.toLowerCase().trim().replace(/[^\w\s]/g, '');
}

function similarity(a: string, b: string): number {
  const na = normalize(a);
  const nb = normalize(b);
  if (na === nb) return 1;
  if (na.includes(nb) || nb.includes(na)) return 0.9;

  const longer = na.length > nb.length ? na : nb;
  const shorter = na.length > nb.length ? nb : na;
  if (longer.length === 0) return 1;

  const costs: number[] = [];
  for (let i = 0; i <= longer.length; i++) {
    let lastValue = i;
    for (let j = 0; j <= shorter.length; j++) {
      if (i === 0) {
        costs[j] = j;
      } else if (j > 0) {
        let newValue = costs[j - 1];
        if (longer.charAt(i - 1) !== shorter.charAt(j - 1)) {
          newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
        }
        costs[j - 1] = lastValue;
        lastValue = newValue;
      }
    }
    if (i > 0) costs[shorter.length] = lastValue;
  }
  return 1 - costs[shorter.length] / longer.length;
}

export interface DuplicateMatch {
  dance: Dance;
  score: number;
}

export function findDuplicates(title: string, formation: string, dances: Dance[]): DuplicateMatch[] {
  if (!title || title.trim().length < 3) return [];

  const matches: DuplicateMatch[] = [];

  for (const dance of dances) {
    const titleScore = similarity(title, dance.title);
    const formationBonus = formation && dance.formation
      && normalize(formation) === normalize(dance.formation) ? 0.05 : 0;
    const score = titleScore + formationBonus;

    if (score >= 0.8) {
      matches.push({ dance, score });
    }
  }

  return matches.sort((a, b) => b.score - a.score).slice(0, 3);
}
